import { render } from "./Materials.vue?vue&type=template&id=e5a052fe&ts=true&lang=pug"
import script from "./Materials.vue?vue&type=script&setup=true&lang=ts"
export * from "./Materials.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__